import React from 'react';

import {
	ArmorClassCard,
	ConditionsCard,
	DefensesCard,
	HitPointsCard,
	InitiativeCard,
	InspirationCard,
	ProficiencyBonusCard,
	SizeCard,
	SpeedCard,
} from './stat-cards';

import css from './sheet.module.css';

/** строка главных показателей под шапкой на узком экране: видна на всех экранах листа */
export const SummaryStrip: React.FC = () => (
	<div className={css.summaryStrip}>
		<ArmorClassCard />
		<HitPointsCard />
		<SpeedCard />
		<InspirationCard />
		<ConditionsCard />
		<InitiativeCard />
		<DefensesCard />
		<SizeCard />
		<ProficiencyBonusCard />
	</div>
);
